import { Directive, HostListener } from '@angular/core';

@Directive({
    selector: '[stopPropagation]',
    standalone: false
})
export class StopPropagationDirective {

  @HostListener('click', ['$event'])
  onClick(event: Event) {
    event.stopPropagation();
  }

  constructor() { }

}
